var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2048 1536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#202020"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 850,
    width: 80,
    height: 520
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 880,
    width: 80,
    height: 470
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 910,
    width: 80,
    height: 420
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 940,
    width: 80,
    height: 520
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 850,
    width: 80,
    height: 470
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 880,
    width: 80,
    height: 420
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 910,
    width: 80,
    height: 520
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525,
    y: 940,
    width: 80,
    height: 470
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 850,
    width: 80,
    height: 420
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675,
    y: 880,
    width: 80,
    height: 520
  }), /*#__PURE__*/React.createElement("rect", {
    x: 750,
    y: 910,
    width: 80,
    height: 470
  }), /*#__PURE__*/React.createElement("rect", {
    x: 825,
    y: 940,
    width: 80,
    height: 420
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 850,
    width: 80,
    height: 520
  }), /*#__PURE__*/React.createElement("rect", {
    x: 975,
    y: 880,
    width: 80,
    height: 470
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050,
    y: 910,
    width: 80,
    height: 420
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1125,
    y: 940,
    width: 80,
    height: 520
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 850,
    width: 80,
    height: 470
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1275,
    y: 880,
    width: 80,
    height: 420
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1350,
    y: 910,
    width: 80,
    height: 520
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1425,
    y: 940,
    width: 80,
    height: 470
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1500,
    y: 850,
    width: 80,
    height: 420
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1575,
    y: 880,
    width: 80,
    height: 520
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1650,
    y: 910,
    width: 80,
    height: 470
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1725,
    y: 940,
    width: 80,
    height: 420
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1800,
    y: 850,
    width: 80,
    height: 520
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1875,
    y: 880,
    width: 80,
    height: 470
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1950,
    y: 910,
    width: 80,
    height: 420
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2025,
    y: 940,
    width: 80,
    height: 520
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.4620ecc6f418a7742314fd7a7b939612.svg";
export { ForwardRef as ReactComponent };